import { environment } from "src/environments/environment";

export interface Breadcrumbs {
  name: string;
  path: string;
  active?: boolean;
}
export class ManualLog {
  LogType: string;
  LogSubActivity: string;
  LogData: string;
  MetaData: string;
  constructor() {
    this.LogType = null;
    this.LogSubActivity = null;
    this.LogData = null;
    this.MetaData = null;
  }
}

export interface Country {
  CountryId: number;
  CountryName: string;
  ISDCode: string;
  CurrencySymbol: string;
  FlagImagePath: string;
  DefaultFlag: number;
  ActiveFlag: number;
  UniqueCode: string;
  PhoneNumLength: number;
}

export interface GlobalCountry {
  GlobalCountryId: number;
  CountryName: string;
  ISDCode: string;
  CurrencySymbol: string;
  FlagImagePath: string;
  DefaultFlag: number;
  ActiveFlag: number;
}

export interface State {
  StateId: number;
  CountryId: number;
  StateName: string;
  UniqueCode: string;
  ActiveFlag: number;
  CountryName: string;
  RowStateFlag: string;
}

export interface District {
  ActiveFlag: number;
  DistrictId: number;
  DistrictName: string;
  StateId: number;
  StateName: string;
  UniqueCode: string;
}

export interface AdminRole {
  AdminRoleId: number;
  AdminRole: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface TransportRoute {
  RouteId: number;
  RouteName: string;
  RouteCode: string;
  ActiveFlag: number;
  InstId: number;
}

export interface CommChannel {
  CommChannelId: number;
  CommChannel: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface AbsentReason {
  AbsentReasonId: number;
  AbsentReason: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface FeeType {
  FeeTypeId: number;
  FeeType: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface FeeFrequency {
  FeeFrequencyId: number;
  FeeFrequency: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface ApprovalStatus {
  ApprovalStatusId: number;
  ApprovalStatus: string;
  UniqueCode: string;
  ActiveFlag: number;
}
export interface AppConfig {
  ConfigId: number;
  ConfigName: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface Unit {
  UnitId: number;
  UnitName: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface VehicleType {
  VehicleTypeId: number;
  VehicleType: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface FuelType {
  FuelTypeId: number;
  FuelType: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface NamePrefix {
  NamePrefixId: number;
  NamePrefix: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface Gender {
  GenderId: number;
  Gender: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface RunCycle {
  RunCycleId: number;
  RunCycleName: string;
  ActiveFlag?: number;
}

export interface IDCardType {
  IDCardTypeId: number;
  IDCardType: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface BloodGroup {
  BloodGroupId: number;
  BloodGroup: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface Relationship {
  RelationshipId: number;
  RelationshipName: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface Religion {
  ReligionId: number;
  ReligionName: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface House {
  HouseId: number;
  HouseName: string;
  UniqueCode: string;
  ActiveFlag: number;
}
export interface Caste {
  CasteId: number;
  CasteName: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface MotherTongue {
  MotherTongueId: number;
  MotherTongue: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface House {
  HouseId: number;
  HouseName: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface TransportationMode {
  TransportationModeId: number;
  TransportationMode: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface Organization {
  OrgId: number;
  OrgCode: string;
  OrgName: string;
  ActiveFlag: number;
}

export interface GlobalOrganization {
  GlobalOrgId: number;
  DBOrgId: number;
  OrgCode: string;
  OrgName: string;
  ActiveFlag: number;
}

export interface GlobalUsr {
  GlobalUsrId: number;
  UsrName: string;
}

export interface Institution {
  OrgId: number;
  InstId: number;
  ActiveFlag: number;
  InstitutionName: string;
  InstitutionCode: string;
}

export interface ApprovalStatus {
  ApprovalStatusId: number;
  ApprovalStatus: string;
  ActiveFlag: number;
}

export interface RouteType {
  RouteTypeId: number;
  RouteType: string;
  ActiveFlag: number;
}

export interface Examination {
  ExaminationId: number;
  ExamName: string;
  ActiveFlag: number;
}

export interface Department {
  DepartmentId: number;
  Department: string;
  ActiveFlag: number;
}

export interface EmpGroup {
  EmpGroupId: number;
  EmpGroup: string;
  ActiveFlag: number;
}

export interface EmpType {
  EmpTypeId: number;
  EmpType: string;
  ActiveFlag: number;
}

export interface Designation {
  DesignationId: number;
  Designation: string;
  ActiveFlag: number;
}

export interface Subjects {
  SubjectId: number;
  SubjectName: string;
  ActiveFlag: number;
}

export interface AcademicSession {
  SessionId: number;
  AcademicYear: string;
  ActiveSession: number;
  ActiveFlag: number;
  StartDate: string;
  EndDate: string;
}

export interface AcademicYear {
  AcademicYear: number;
  AcademicYearId: number;
  ActiveFlag: number;
  UniqueCode: string;
}

export interface AcademicClass {
  ClassId: number;
  ClassName: string;
  ActiveFlag: number;
}

export interface Section {
  SectionId: number;
  SectionName: string;
  ActiveFlag: number;
}

export interface ExamType {
  ExamTypeId: number;
  ExamType: string;
  ActiveFlag: number;
}

export interface AnswerType {
  AnswerTypeId: number;
  AnswerType: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface CalenderMonth {
  CalenderMonthId: number;
  CalenderMonth: string;
  ActiveFlag: number;
}

export interface WeekDays {
  WeekDayId: number;
  DisplayName: string;
  ActiveFlag: number;
}

export interface PeriodType {
  PeriodTypeId: number;
  PeriodType: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface ColorPattern {
  ColorPatternId: number;
  ColorPattern: string;
  ActiveFlag: number;
}

export interface AbsentReason {
  AbsentReasonId: number;
  AbsentReason: string;
  ActiveFlag: number;
}

export interface ExamGrade {
  ExamGradeId: number;
  ExamGrade: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface DocumentCategory {
  DocumentCategoryId: number;
  DocumentCategory: string;
  UniqueCode: string;
  ActiveFlag: number;
}

export interface Room {
  ClassRoomId: number;
  RoomName: string;
}

export interface Employee {
  EmpId: number;
  OrgId: number;
  FullName: string;
  ActiveFlag: number;
  EmployeeCode: string;
}

export interface RequestHeader {
  UsrId: string | number;
  // OrgId: string | number;
  // OrgCode: string;
  PortalUsrId: string | number;
  Source: string;
  OperationKey: string;
  SubOperationKey: string;
  IncludeTrxData: number;
  IncludeMasterData: number;
  DriveCode: string;
}

export interface BusinessData {
  Object?: any;
}

export interface UserData {
  DeviceId: string;
  DeviceMake: string;
  DeviceModel: string;
  OSName: string;
  OSVersion: string;
  FirebaseToken: string;
}

export interface RequestBody {
  BusinessData: BusinessData;
  UserData: UserData;
}

export interface ResponseBody {
  Header: {
    Status: string;
    AuthToken?: string;
  };
  Body: {
    Object: any;
    BusinessData: any;
    MasterData: any;
  };
  Error: {
    Type: string;
    ErrorNo: number;
    ErrorMessage: string;
    ErrorDescription: string;
  };
}

export class RequestPayload {
  Header: RequestHeader;
  Body: RequestBody;

  constructor(
    private orgId: string,
    private orgCode: string,
    private operationKey: string,
    private subOperationKey: string,
    private businessDataObject: any,
    private userId: any = null,
    private userData: any = null,
    private masterData: boolean = true,
    private transactionData: boolean = true,
    private portalUsrId: any = null,
  ) {
    this.Header = {
      ...this.Header,
      Source: 'ADMIN',
      // OrgId: this.orgId,
      UsrId: this.userId,
      // OrgCode: this.orgCode,
      PortalUsrId: this.portalUsrId,
      OperationKey: this.operationKey,
      SubOperationKey: this.subOperationKey,
      IncludeMasterData: this.masterData ? 1 : 0,
      IncludeTrxData: this.transactionData ? 1 : 0,
      DriveCode: environment.DbCode ? environment.DbCode : ''
    };
    this.Body = {
      ...this.Body,
      BusinessData:
        !!this.businessDataObject &&
          !!this.businessDataObject.Object &&
          !!this.businessDataObject.hasOwnProperty('Object')
          ? { ...this.businessDataObject }
          : { Object: this.businessDataObject },
      UserData: this.userData,
    };
  }
}

export interface AdminConfig {
  GlobalConfigId: number;
  ConfigCode: string;
  ConfigName: string;
  ConfigValue: any;
}

export interface GlobalLogin {
  Email: string;
  AdminPassword: string;
}

export interface GlobalLoginValidateOTP extends GlobalLogin {
  InputOTP: number;
}

export interface GlobalResetPassword extends GlobalLogin {
  DOB: string;
  InputOTP: number;
}

export interface GlobalChangePassword extends GlobalLogin {
  DOB: string;
  InputOTP: number;
}

export interface GlobalUserInfo {
  Email: string;
  UsrName: string;
  MobileCode: string;
  SuperAdmin: number;
  GlobalUsrId: number;
  MobileNumber: string;
  TempPasswordFlag: number;
}

export interface OrgMap {
  UsrId: number;
  OrgId: number;
  OrgCode: string;
  OrgName: string;
  SuperAdminFlag: string;
  UniversalAppLink: string;
  OrgLogoImg: string;
  GlobalUsrId: number;
}

export interface UserMenu {
  MenuCode: string;
  AdminMenuId: number;
  SubMenu: UserMenu[];
  AdminMenuName: string;
  IconName: string;
  RoutePrefix: string;
  DefaultScreenCode: string;
}

export interface UserScreen {
  MenuCode: string;
  AdminRole: string;
  ScreenCode: string;
  AdminScreen: string;
  AdminRoleId: number;
  AdminMenuId: number;
  ReadOnlyFlag: number;
  AdminScreenId: number;
}

export interface UserAdminLandingFetch {
  UsrId: number;
  ObjectType: string;
}

export interface GlobalLogout {
  Email: string;
  MobileCode: string;
  MobileNumber: string;
}

export interface StudentSearchInput {
  TableName: string;
  InputId: number;
  InputName: string;
  IncludeActive: number;
  IncludeInActive: number;
}

export interface StudentSearchOutput {
  StudentId?: number;
  SystemRegNum: string;
  RegistrationCode: string;
  StudentName: string;
  InstitutionName: string;
  ClassName: string;
  SectionName: string;
  RollNumber: string;
  StudentGrade: string;
  GuardianName: string;
  GuardianPhone: string;
  StudentCode: string;
  FullName: string;
  ProfileCompletionPercentage: string;
  ActiveFlag: number;
  AdmissionStatus: string;
  PhoneNum: string;
  Email:string;
  DOB:string;
  ActualCategoryName:string;
  TotalRecordCount?:number;
}

export class CommunicationInfo {
  General: CommunicationData;
}
export class CommunicationData {
  CommunicationType: string;
  TranDBFlag: number;
  AppUsrId: string;
  AppUsrName: string;
  Email: string;
  MobileCode: string;
  MobileNumber: string;
  MessageTitle: string;
  MessageBody: string;

  SMSFlag: boolean;
  EmailFlag: boolean;
  NotificationFlag: boolean;

  constructor() {
    this.SMSFlag = false;
    this.EmailFlag = false;
    this.NotificationFlag = false;
    this.MessageTitle = null;
    this.MessageBody = null;
  }
}

export interface University {
  UniversityId: number;
  UniversityCode: string;
  UniversityName: string;
  ActiveFlag: number;
}

export interface CollegeType {
  CollegeTypeId: number;
  UniqueCode: number;
  CollegeType: number;
  ActiveFlag: number;
}

export interface College {
  CollegeId: number;
  UniversityId: number;
  CollegeCode: string;
  CollegeName: string;
  UniversityName: string;
  ActiveFlag: number;
  TestCompletedFlag: number;
}

export const ADMIN_CONSTANT = {
  TOAST_DURATION_LOW: 1000,
  TOAST_DURATION_HIGH: 5000,
  TOAST_DURATION_MEDIUM: 3000,
  RESEND_OTP_TIMER: 60,
  TIMER_DURATION_ULTRA_HIGH: 60000,
  ADMIN_SEARCH_PAGE_SIZE: 10,
  ADMIN_DETAIL_PAGE_SIZE: 10,
  ADMIN_REPORT_PAGE_SIZE: 25,

  STATUS_TRUE: 'TRUE',
  STATUS_FALSE: 'FALSE',
  ERROR_STATUS: 'Error',
  SUCCESS_STATUS: 'Success',
  SITE_NOT_RUNNING: 'MAINT',
  USER_OBJECT_TYPE: 'AdminUser',
  USER_INST_OBJECT_TYPE: 'Inst',
  USER_UNIVERSITY_OBJECT_TYPE: 'University',
  USER_COLLEGE_OBJECT_TYPE: 'College',
  ROLE_OBJECT_TYPE: 'AdminRole',
  USER_COURSE_OBJECT_TYPE: 'Course',
  BOTAPP_OBJECT_TYPE: 'BotApp',
  USER_MSG_OBJECT_TYPE: 'Msg',
  USER_PROFILE_ACTION: 'LOGOUT',
  USER_PROFILE_SWITCH: 'SWITCH',
  USER_PROFILE_CHANGE_PWD: 'PWD',
  SITE_UNDER_MAINTENANCE: 'MAINT',
  SITE_TWO_FACTOR_AUTHENTICATION: '2FA',
  CONFIG_COMMUNICATION_OBJECT_TYPE: 'CommunicationTemplate',
  CONFIG_RUNCYCLE_DASHBOARD: 'Dashboard',
  GALLERY_OBJECT_TYPE: 'Gallery',

  BOARD_OBJECT_TYPE: 'Board',



  // Server Messages
  SERVER_ERROR_MESSAGE: 'Having some problem contacting server',
  OTP_DELIVERED_MESSAGE: 'OTP delivered, please check',
  OTP_VALIDATED: 'Credentials successfully validated',
  FORM_INVALID: 'Form is not valid',
  FORM_UNTOUCHED: 'No data to Save',
  // End Server Messages

  // Access Related Messages
  NO_RECORDS_FOUND: 'No records found',
  NO_ACCESS: 'Your role do not have permission to access',
  READ_ONLY_ACCESS: 'Your role have only read-only access',
  NON_EDITABLE_ACCESS: 'Selected Object is read-only',
  // End Access Related Messages

  // Online & Offline Message
  ONLINE_MESSAGE: 'Your connection restored',
  OFFLINE_MESSAGE: 'You are currently offline',
  // End Online & Offline Message

  // Tokens for session-storage
  ADMIN_TOKEN_TIMER: 'TIMER',
  ADMIN_TOKEN_ORG_ID: 'ORGID',
  ADMIN_TOKEN_USER_ID: 'USERID',
  ADMIN_TOKEN_ORG_CODE: 'ORGCODE',
  ADMIN_TOKEN_AUTH_TOKEN: 'AUTHTOKEN',
  ADMIN_TOKEN_ADMIN_CONFIG: 'ADMINCONFIG',
  ADMIN_TOKEN_REFRESH_TOKEN: 'REFRESHTOKEN',
  ADMIN_TOKEN_ADMIN_USER_DATA: 'ADMINUSERDATA',
  ADMIN_TOKEN_PUSH_NOTIFICATION: 'ADMINPUSHNOTIFICATION',
  ADMIN_TOKEN_ADMIN_GLOBAL_USER_INFO: 'ADMINGLOBALUSERINFO',
  ADMIN_TOKEN_ADMIN_USER_MENU_SCREEN: 'ADMINUSERMENUSCREEN',
  ADMIN_TOKEN_ADMIN_SELECTED_ULINK: 'ADMINSELECTEDORGULINK',
  ADMIN_TOKEN_ADMIN_SUPER_USER_FLAG: 'ADMINSUPERUSERFLAG',
  ADMIN_TOKEN_ADMIN_SELECTED_ORGANIZATION: 'ADMINSELECTEDORGANIZATION',
  ADMIN_TOKEN_COURSE_SEARCH_PARAMETERS: 'COURSESEARCHPARAMETERS',
  // End Tokens for session-storage

  GLOBAL_ADMIN_SETTING: 'AdminSetting',
  GLOBAL_LOGIN: 'AdminLogin',
  GLOBAL_LOGIN_VALIDATE_OTP: 'AdminLoginValidateOTP',
  GLOBAL_LOGOUT: 'AdminLogout',
  GLOBAL_RESET_PASSWORD: 'AdminResetPassword',
  GLOBAL_LOGIN_RESEND_OTP: 'AdminLoginResendOTP',
  USER_ADMIN_LANDING_FETCH: 'UserAdminLandingFetch',
  GLOBAL_RESET_PASSWORD_VALIDATE: 'AdminResetPasswordValidateOTP',
  GLOBAL_RESET_PASSWORD_RESEND_OTP: 'AdminResetPasswordResendOTP',

  //Change or Reset Password

  GLOBAL_CHANGE_PASSWORD: 'AdminChangePassword',
  GLOBAL_CHANGE_PASSWORD_VALIDATE: 'AdminChangePasswordValidateOTP',
  GLOBAL_CHANGE_PASSWORD_RESEND_OTP: 'AdminChangePasswordResendOTP',



  // Institution API DETAILS
  USER_ADMIN_INST_ROOM_DETAIL_FETCH: 'InstRoomFetch',
  USER_ADMIN_INST_ROOM_DETAIL_SAVE: 'InstRoomSave',
  USER_ADMIN_INST_DETAIL_SEARCH: 'InstDetailSearch',
  USER_ADMIN_INST_DETAIL_FETCH: 'InstDetailFetch',
  USER_ADMIN_INST_DETAIL_SAVE: 'InstDetailSave',
  // End Institution API DETAILS

  // Job API Details
  JOB_REQUEST_MASTER_DATA: 'GlobalJobRequestMaster',
  JOB_REQUEST_SEARCH: 'GlobalJobRequestList',
  JOB_EMP_PREPARE_TEMPLATE: 'BulkEmpDownloader',
  JOB_STD_PREPARE_TEMPLATE: 'BulkStudentDownloader',
  JOB_EMP_UPLOAD_TEMPLATE: 'BulkEmpUploader',
  JOB_STD_UPLOAD_TEMPLATE: 'BulkStudentUploader',

  my_AntiRaggingMsgOne: 'I confirm that I have read UGC’s regulations on Ragging.',
  my_AntiRaggingMsgOntwo: "I confirm that I have read the judgment of the Hon'ble. Supreme Court on prevention of Ragging.",
  my_AntiRaggingMsgThree: 'I promise that I will not indulge in Ragging or any form of violent behavior. Neither will I tolerate being ragged or subjected to violence.',
  my_AntiRaggingMsgFore: 'I understand that if I am accused of Ragging, the responsibility is on me to prove that I am not guilty.',
  my_AntiRaggingMsgFive: 'I will not remain a spectator to acts of Ragging. I will report the matter immediately to my Principal/Director and /or to the Anti-Ragging Help line at 1800 180 5522 or email to info@antiragging.in',
  my_AntiRaggingMsgSix: 'I have read and understood the above statements and I hereby solemnly pledge  to fill the anti-ragging affidavit in ',
  my_AntiRaggingMsgSeven: ' before taking admission and submit the reference ID at the College/University during verification of documents.',
  CONSENT_MESSAGE: 'I do hereby solemnly declare that all the information provided in this application are true, complete and correct to the best of my knowledge and belief. In the event of any information found to be false, incomplete or incorrect, my candidature is liable to be cancelled even after admission as per rules now in force.',
  CONSENT_MESSAGE_BEFORE: 'I solemnly declare that I have read and understood the rules and regulations of admission to the undergraduate courses/programmes of all Universities/Colleges/HEIs of West Bengal and that I am applying for admission to UG course(s)/programmes after fully understanding the rules/regulations/eligibility criteria etc. set forth by the Affiliating Universities or Higher Education Institutions as the case may be. I further declare that if my application turns out to be invalid for not understanding any rule/regulation or part thereof on my part, I alone shall be held responsible for such invalidation, if any.',
  PREVIEW_CHECKBOX_TEXT: 'Checked and verified by me',
  PROFILE_UNLOCK_MSG: '( Please note that your all selected preference will be deleted. )',
  DATA_PROTECTION: "I do hereby authorize the West Bengal State Council of Higher Education to use and process my 'digital personal data' in the light of 'Digital Personal Data Protection Act, 2023'  for the purpose for which the same have been digitally captured by the system for lawful purposes and for matters connected therewith or incidental thereto.",

  // End
};

export interface University {
  ActiveFlag: number;
  UniversityCode: string;
  UniversityId: number;
  UniversityName: string;
}

export interface CollegeSearchInput {
  TableName: string;
  InputId: number;
  InputName: string;
  IncludeActive: number;
  IncludeInActive: number;
}

export interface CollegeType {
  ActiveFlag: number;
  CollegeType: number;
  CollegeTypeId: number;
  UniqueCode: number;
}

export interface NamePrefix {
  ActiveFlag: number;
  NamePrefix: string;
  NamePrefixId: number;
  UniqueCode: string;
}

export interface Gender {
  Gender: string;
  UniqueCode: string;
}

export interface CollegeCategory {
  CollegeCategory: string;
  CollegeCategoryId: number;
  ActiveFlag: number;
  UniqueCode: string;
}


export const GLOBAL_CONSTANTS = {
  DOB_FORMAT: 'MM/DD/YYYY',
  RESEND_OTP_TIMER: 60,
  TIMER_DURATION_ULTRA_HIGH: 60000,
}